import React, {useEffect, useState} from 'react';
import {Grid, makeStyles, useMediaQuery, useTheme} from '@material-ui/core';
import ExperienceBuilderStart from './start';
import CreatorSidebar from '../../../atoms/creator/experienceBuilderSidebar';
import {useDispatch, useSelector} from "react-redux";
import MultiWaysInvite from './liveExperience/multiWaysInvite';
import LiveExperienceFinish from './liveExperience/finish';
import LiveExperienceReview from './liveExperience/review';
import LiveExperienceAddAgenda from './liveExperience/addAgenda';
import LiveExperienceCalendarBasedInvite from './liveExperience/calendarBasedInvite';
import LiveExperienceCalendarLinkBasedInvite from './liveExperience/linkBasedFlow';
import PreRecordedInvitingPath from "./pre-recorded/invitingPath";
import PreRecordedSchedule from "./pre-recorded/schedule";
import PreRecordedVideoPath from "./pre-recorded/videoPath";
import PreRecordedReview from "./pre-recorded/review";
import PreRecordedFinish from "./pre-recorded/finish";
import CreatorCloseBtnModal from '../../../atoms/modals/creatorCloseBtnModal';
import {
  emptyUserMetrics,
  experienceCategories,
  getUserMetricValue,
  moveNextPage,
  updateUserMetrics
} from '../../../../store/actions/creator/creatorExperienceBuilder';
import {Helmet} from "react-helmet";
import {useHistory} from "react-router";
import {Prompt} from 'react-router-dom';
import {getExperiencesTotal} from '../../../../store/actions/experience/experience';
import UtilService from "../../../../helper/service";
import roles from "../../../../helper/roles";
import TrialGreatChoice from "./trial/greatChoice";
import {getConfigurationDetails, getUserPreferences} from "../../../../store/actions";
import TrialFirstChoice from "./trial/firstChoice";
import clsx from 'clsx';
import useWindowSize from '../../../../helper/hooks/useWindowSize';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import PlanningMeasure from "./planningMeasure";
import ParticipantLists from "../../participant/list/IndexPage";
import HubConnect from "./liveExperience/hubConnect";
import CreateAutomation from './createAutomation';
import PreReelSessions from "../reelsBuilder/reels/reelSessions";
import PreReelName from "../reelsBuilder/reels/reelName";
import ReelsInviting from "../reelsBuilder/reels/reelsInviting";
import ReelSchedule from "../reelsBuilder/reels/schedule";
import ReelReview from "../reelsBuilder/reels/review";
import ReelFinish from "../reelsBuilder/reels/finish";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'auto'
  },
  h100: {
    height: '100%',
  },
  container: {
    flex: 1,
    paddingLeft: 20,
    paddingRight: 20
  },
  left: {
    width: 240,
  },
  closeBtn: {
    position: 'absolute',
    right: 40,
    top: 30,
    '&:hover': {
      cursor: 'pointer',
      background: "#f0f0f0",
      border: "1px solid #d9d9d9",
      padding: "3px 1px 0px 1px",
      borderRadius: 3
    }
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  icon: {
    color: '#888',
    position: 'absolute',
    left: 22,
    top: 24,
    fontSize: 28,
    background: '#fff'
  }
}));

function ExperienceBuilder() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    page, userMetrics, globalSaveSetting, globalCompatible
  } = useSelector((state: any) => state.creatorExperienceBuilder);
  const {
    path, moderatedInviteWay, myOwn, trialFirstStep, asyncParticipants, moderatedCompleted, asyncCompleted,
    addParticipantList, createReel, sessions
  } = userMetrics; // path = 1: pre-recorded, path = 2: liveexperience
  const [modal, setModal] = useState(false);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const [fieldChanged, setFieldChange] = useState(true);
  const [confirmationLeavePage, setConfirmationLeavePage] = useState(false);
  const { totalExperienceCount } = useSelector((state: any) => state.experience);
  const [displayCloseBtn, setDisplayCloseBtn] = useState(true);
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'));
  const [isOpen, setIsOpen] = useState(false);
  const { width } = useWindowSize();

  useEffect(() => {
    window.onpopstate = () => {
      const hash = history.location.hash;
      switch (hash) {
        case '#start':
        case '#first':
          dispatch(emptyUserMetrics());
          dispatch(moveNextPage(0));
          return;
        case '#async0':
          dispatch(moveNextPage(0));
          dispatch(updateUserMetrics('path', 1));
          dispatch(updateUserMetrics('myOwn', false));
          return;
        case '#async1':
          dispatch(moveNextPage(0));
          dispatch(updateUserMetrics('path', 1));
          dispatch(updateUserMetrics('content', ''));
          isFirstTimeBuilding() && dispatch(updateUserMetrics('myOwn', true));
          return;
        case '#async2':
          dispatch(moveNextPage(0));
          dispatch(updateUserMetrics('path', 1));
          return;
        case '#media':
          dispatch(moveNextPage(1));
          dispatch(updateUserMetrics('path', 1));
          return;
        case '#schedule':
        case '#calendar':
          dispatch(moveNextPage(2));
          return;
        case '#invite':
          dispatch(moveNextPage(3));
          return;
        case '#asyncgo':
          dispatch(moveNextPage(4));
          dispatch(updateUserMetrics('path', 1));
          return;
        case '#mod1':
          dispatch(moveNextPage(0));
          dispatch(updateUserMetrics('path', 2));
          dispatch(updateUserMetrics('content', ''));
          return;
        case '#mod2':
          dispatch(moveNextPage(0));
          dispatch(updateUserMetrics('path', 2));
          return;
        case '#mod3':
          dispatch(moveNextPage(1));
          dispatch(updateUserMetrics('path', 2));
          return;
        case '#agenda':
          dispatch(moveNextPage(4));
          dispatch(updateUserMetrics('path', 2));
          return;
        case '#modgo':
          dispatch(moveNextPage(5));
          dispatch(updateUserMetrics('path', 2));
          return;
        case '#created':
          path === 1 ? dispatch(moveNextPage(5)) : dispatch(moveNextPage(6));
          return;

      }
    }
  }, [window, history.location.hash, path]);

  useEffect(() => {
    dispatch(experienceCategories(apolloClient.client));
    dispatch(getExperiencesTotal(apolloClient.client, { user_id: loginUserData.user_id }));
    const req = {
      "tenant_id": loginUserData.customer_id
    };
    dispatch(getConfigurationDetails(apolloClient.client, req));
    const request = {
      metrix_type: 'EXPERIENCE_CREATE_SETTING',
      user_id: Number(loginUserData.user_id)
    };
    dispatch(getUserMetricValue(apolloClient.client, request));
    dispatch(getUserPreferences(apolloClient.client, {user_id: loginUserData.user_id}))
  }, [apolloClient.client]);

  useEffect(() => {
    if (totalExperienceCount !== null) {
      totalExperienceCount === 0 ? setDisplayCloseBtn(false) : setDisplayCloseBtn(true);
    }
  }, [totalExperienceCount]);

  useEffect(() => {
    if (globalSaveSetting && (globalCompatible === 0 || globalCompatible === 1)) {
      const me = asyncParticipants.find((p: any) => p.email === loginUserData.username);
      if (!me) {
        const participant = {
          email: loginUserData.username,
          tags: '',
          is_csv: false
        };
        dispatch(updateUserMetrics('asyncParticipants', asyncParticipants.concat([participant])));
      }
    } else {
      dispatch(updateUserMetrics('asyncParticipants', []));
    }
  }, [globalCompatible, globalSaveSetting]);


  // useEffect(()=>{
  //   const request = {
  //     temporary_value: userMetrics,
  //     user_id: loginUserData.user_id,
  //   }
  //   initialLoad && dispatch(updateUserAttributes(apolloClient.client, request))
  // },[apolloClient.client, loginUserData.user_id, dispatch, initialLoad, page])
  //
  // useEffect(()=>{
  //   const request = {
  //     user_id: loginUserData.user_id,
  //   }
  //   dispatch(getUserAttributes(apolloClient.client, request))
  //
  // },[initialLoad, apolloClient.client, dispatch, loginUserData.user_id])

  useEffect(() => {
    if (!fieldChanged) {
      history.push(`${confirmationLeavePage}`);
      dispatch(emptyUserMetrics());
      dispatch(moveNextPage(0));
      setConfirmationLeavePage(false)
    }
  }, [fieldChanged]);

  useEffect(() => {
    window.addEventListener('click', winsoPOP);
    return () => {
      window.removeEventListener('click', winsoPOP);
    };
  });

  const toggleDrawer = (open: any) => (event: any) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsOpen(open);
  };

  const winsoPOP = (e: any) => {
    const data = e.path;
    if (!data) return;
    data.map((val: any) => {
      if (val.id === "id_/creator/dashboard") {
        history.push('/dashboardUrl')
      }
    })
  };

  const clickCloseIcon = () => {
    if ((page === 5 && path === 1) || (page === 6 && path === 2 && moderatedInviteWay === 'link')) {
      // do'nt show modal and go to necessary page on the final building page
      onApply();
    } else {
      setModal(true);
    }
  };

  const handleClose = () => {
    setModal(false);
    setConfirmationLeavePage(false);
  };

  const onApply = () => {
    if (confirmationLeavePage) {
      redirectToNewPage();
    } else {
      dispatch(emptyUserMetrics());
      setConfirmationLeavePage(false);
      setFieldChange(false);
      handleClose();
      goto();
    }
  };

  const goto = () => {
    let url = '/creator/dashboard';
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
      url = '/subscriber/creator/dashboard';
    }
    history.push(url);
  };

  // check redirect to page
  const handleBlockedNavigation = (e: any) => {
    if (e.pathname === '/creator/experience-builder' || e.pathname === '/subscriber/creator/experience-builder') {
      return true;
    }
    if (
      (page === 5 && path === 1)
      || (page === 6 && path === 2 && moderatedInviteWay === 'link')
      || moderatedCompleted
      || asyncCompleted
    ) {
      setConfirmationLeavePage(e.pathname);
      return true;
    } else {
      if (fieldChanged) {
        setConfirmationLeavePage(e.pathname);
        return false
      } else {
        setConfirmationLeavePage(false);
        return true
      }
    }
  };

  // redirect to new page after confirm
  const redirectToNewPage = () => {
    if (confirmationLeavePage) {
      const oldHistory: any = confirmationLeavePage;
      let dashboardUrl: any = "/creator/dashboard";
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
        dashboardUrl = "/subscriber/creator/dashboard";
      }
      if (oldHistory.includes("/dashboardUrl")) {
        setConfirmationLeavePage(dashboardUrl)
      } else {
        // page=confirmationLeavePage
      }
    }
    setFieldChange(false)
  };

  const loadDashboardPage = () => {
    setFieldChange(false);
    let dashboardUrl: any = "/creator/dashboard";
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
      dashboardUrl = "/subscriber/creator/dashboard";
    }
    setConfirmationLeavePage(dashboardUrl)
  };

  const isFirstTimeBuilding = () => {
    return !!(totalExperienceCount !== null && totalExperienceCount === 0);
  };

  const onRemoveReelSession = (reelSession: any) => {
    const currentSessions = [...sessions];
    const updatedSessions = currentSessions.filter((session: any) => session.session_code !== reelSession.session_code);
    dispatch(updateUserMetrics('sessions', updatedSessions));
  };

  return (
    <>
      {isMobileDevice && <CreateAutomation />}
      {!isMobileDevice &&
        <div style={{ height: '100%' }}>
          {addParticipantList ? (
            <ParticipantLists />
          ) : (
            <div className={clsx(classes.root, classes.h100)}>
              <Helmet title="Experience Builder" />

              <div>
                <React.Fragment>
                  <MenuIcon className={classes.icon} onClick={toggleDrawer(true)} />
                  <Drawer anchor={'left'} open={isOpen} onClose={toggleDrawer(false)}>
                    <CreatorSidebar />
                  </Drawer>
                </React.Fragment>
              </div>

              <div className={classes.left}>
                <CreatorSidebar />
              </div>
              {displayCloseBtn && (
                <div className={classes.closeBtn} onClick={clickCloseIcon}>
                  <img src={'/assets/icons/experiencebuilder/close-icon.svg'} alt={'close icon'} />
                </div>
              )}

              <Grid container justifyContent={'center'} className={classes.container} style={{ marginLeft: width >= 850 ? -140 : 0 }}>
                {isFirstTimeBuilding() ? (
                  <>
                    {(page === 0 && trialFirstStep) && <Grid className={classes.flexCenter} item lg={7} md={10} sm={12}><TrialFirstChoice /></Grid>}
                    {(page === 0 && path === 1 && !trialFirstStep && !myOwn) && <Grid item lg={7} md={10} sm={12}><TrialGreatChoice /></Grid>}
                    {(page === 0 && path === 1 && !trialFirstStep && myOwn) && <Grid item lg={7} md={10} sm={12}><ExperienceBuilderStart /></Grid>}
                    {(page === 0 && path === 2 && !trialFirstStep) && <Grid item lg={7} md={10} sm={12}><ExperienceBuilderStart /></Grid>}
                  </>
                ) : (
                  page === 0 && <Grid item lg={7} md={10} sm={12}><ExperienceBuilderStart /></Grid>
                )}
                {page === 1 && path === 1 && <Grid item lg={7} md={10} sm={12}><PreRecordedVideoPath /></Grid>}
                {page === 2 && path === 1 && (
                  createReel ? (
                    <Grid item lg={7} md={10} sm={12}><PreReelSessions selected={sessions} onRemove={onRemoveReelSession} /></Grid>
                  ) : (
                    <Grid item lg={7} md={10} sm={12}><PreRecordedSchedule /></Grid>
                  )
                )}
                {page === 3 && path === 1 && (
                  createReel ? (
                    <Grid className={classes.alignCenter} item lg={7} md={10} sm={12}>
                      <PreReelName selected={sessions} onRemove={(item:any)=>onRemoveReelSession(item)} clickCloseIcon={() => clickCloseIcon()}  />
                    </Grid>
                  ) : (
                    <Grid className={classes.alignCenter} item lg={10} md={10} sm={12}>
                      <PlanningMeasure />
                    </Grid>
                  )
                )}
                {page === 4 && path === 1 && (
                  createReel ? (
                    <Grid item lg={7} md={10} sm={12}><ReelSchedule /></Grid>
                  ) : (
                    <Grid className={classes.alignCenter} item lg={10} md={10} sm={12}><PreRecordedInvitingPath isPreRecorded={true} /></Grid>
                  )
                )}
                {page === 5 && path === 1 && (
                  createReel ? (
                    <Grid className={classes.alignCenter} item lg={7} md={10} sm={12}><ReelsInviting /></Grid>
                  ) : (
                    <Grid item lg={8} md={10} sm={12}><PreRecordedReview /></Grid>
                  )
                )}
                {page === 6 && path === 1 && (
                  createReel ? (
                    <Grid item lg={8} md={10} sm={12}><ReelReview selected={sessions} onRemove={(item:any) => onRemoveReelSession(item)} /></Grid>
                  ) : (
                    <Grid item lg={10} md={10} sm={12}>
                      <PreRecordedFinish
                        setConfirmationLeavePage={setConfirmationLeavePage}
                        setFieldChange={setFieldChange}
                      />
                    </Grid>
                  )
                )}
                {page === 7 && path === 1 && createReel && (
                  <Grid item lg={10} md={10} sm={12}>
                    <ReelFinish
                      setConfirmationLeavePage={setConfirmationLeavePage}
                      setFieldChange={setFieldChange}
                    />
                  </Grid>
                )}

                {page === 1 && path === 2 && <Grid item xl={6} lg={9} md={10} sm={12}><MultiWaysInvite /></Grid>}
                {page === 2 && path === 2 && (
                  <>
                    {(moderatedInviteWay === 'link' || moderatedInviteWay === 'hub') && <Grid item lg={7} md={10} sm={12}><LiveExperienceCalendarLinkBasedInvite /></Grid>}
                    {moderatedInviteWay === 'calendar' && <Grid item lg={9} md={10} sm={12}><LiveExperienceCalendarBasedInvite loadDashboardPage={loadDashboardPage} /></Grid>}
                  </>
                )}

                {page === 3 && path === 2 && moderatedInviteWay === 'link' && !globalSaveSetting &&
                <Grid className={classes.alignCenter} item lg={10} md={10} sm={12}><PlanningMeasure /></Grid>}

                {page === 4 && path === 2 && (
                  <>
                    {moderatedInviteWay === 'link' && <Grid className={classes.alignCenter} item lg={10} md={10} sm={12}><PreRecordedInvitingPath isPreRecorded={false} /></Grid>}
                    {moderatedInviteWay === 'hub' && <Grid className={classes.alignCenter} item lg={10} md={10} sm={12}><HubConnect /></Grid>}
                  </>
                )}

                {page === 5 && path === 2 && moderatedInviteWay !== 'calendar' && <Grid item lg={8} md={10} sm={12}><LiveExperienceAddAgenda /></Grid>}

                {page === 6 && path === 2 && moderatedInviteWay !== 'calendar' && <Grid item lg={8} md={10} sm={12}><LiveExperienceReview /></Grid>}

                {page === 7 && path === 2 && moderatedInviteWay !== 'calendar' && <Grid item lg={8} md={10} sm={12}>
                  <LiveExperienceFinish
                    setConfirmationLeavePage={setConfirmationLeavePage}
                    setFieldChange={setFieldChange} />
                </Grid>}
              </Grid>

              <CreatorCloseBtnModal
                open={modal || !!confirmationLeavePage}
                onClose={handleClose}
                onApply={onApply}
              />
              <Prompt
                when={fieldChanged}
                message={handleBlockedNavigation}
              />
            </div>
          )}
        </div>
      }
    </>
)}

export default ExperienceBuilder;
